import { createTracker } from 'usage-tracker-public';
import commonTrackerProperties from 'pricing-pages-ui/utils/tracking/commonTrackerProperties';
export default (() => createTracker(Object.assign({}, commonTrackerProperties, {
  isExternalHost: false
})));